// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"9c21b363901e03a1","6831":"d18adc15a5863927","8503":"08e21f36012ee76d","9683":"9e0d66aa904ed88c"}[chunkId] + ".js";
};